export default function authorDetails(author) {
  let authorDetails = [];

  if (author.authorName) {
    for (let prop in author) {
      if (author[prop] !== null) {
        authorDetails.push(author[prop]);
      }
    }
    return authorDetails.join(", ");
  }
}
